// @flow

import React from 'react';

import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import { CAREERS_DOMAIN } from '../util/config';

const styles = theme => ({
  careersContainer: {
    textAlign: 'center',
    margin: '10px 0',
  },
  careersLink: {
    textDecoration: 'none',
  },
});

type Props = {
  classes: Object,
  org: Org,
  t: (value: string, opts?: any) => string,
}

const CareersPageButtonComponent = ({ classes, org, t }: Props) => (
  <div className={classes.careersContainer}>
    <Button variant="outlined" component="a" href={`${CAREERS_DOMAIN}/${org.org_key}`} className={classes.careersLink} target="blank" rel="noopener noreferrer">
      {t('viewAllJobs', { orgName: org.name })}
    </Button>
  </div>
);

export const CareersPageButton = withTranslation()(withStyles(styles)(CareersPageButtonComponent))
